var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { usePaginationQuery } from '@/hooks';
import useSessionStorage from '@/hooks/use-session-storage';
import { createContext, useCallback, useContext, useState } from 'react';
import { getMyJobs } from '../../api/my-jobs.api';
import { useConfigContext } from './config-context';
var MyJobsContext = createContext(null);
export var MyJobsProvider = function (_a) {
    var isApplied = _a.isApplied, isSaved = _a.isSaved, children = _a.children;
    var _b = useState('recommended'), sortBy = _b[0], setSortBy = _b[1];
    var _c = useSessionStorage({
        key: 'jobFilters',
        initialValue: {
            appliedFilters: [],
        },
        config: { raw: false },
    }), filters = _c[0], setJobFilters = _c[1], removeFilters = _c[2];
    var jobListingPageUrl = useConfigContext().config.jobListingPageUrl;
    var getMyJobsQueryFn = useCallback(function (page) {
        var filters = {};
        if (isApplied) {
            filters['applied'] = 1;
        }
        if (isSaved) {
            filters['saved'] = 1;
        }
        return getMyJobs(page, filters, sortBy);
    }, [isApplied, isSaved, sortBy]);
    var _d = usePaginationQuery({
        queryFn: getMyJobsQueryFn,
    }), jobs = _d.data, isLoading = _d.isLoading, isLoadingMore = _d.isLoadingMore, hasMore = _d.hasMore, refetchJobs = _d.refetch, fetchNextPage = _d.fetchNextPage, setJobs = _d.setData;
    var updateJob = useCallback(function (jobId, jobPayload) {
        setJobs(jobs.map(function (job) { return (job.jobId === jobId ? __assign(__assign({}, job), jobPayload) : job); }));
    }, [jobs, setJobs]);
    var setFilters = useCallback(function (value) {
        setJobFilters(value);
        window.location.href = jobListingPageUrl !== null && jobListingPageUrl !== void 0 ? jobListingPageUrl : '/';
    }, [setJobFilters, jobListingPageUrl]);
    return (_jsx(MyJobsContext.Provider, { value: {
            jobs: jobs,
            isLoading: isLoading,
            isLoadingMore: isLoadingMore,
            hasMore: hasMore,
            refetchJobs: refetchJobs,
            fetchNextPage: fetchNextPage,
            setSortBy: setSortBy,
            updateJob: updateJob,
            setFilters: setFilters,
            removeFilters: removeFilters,
        }, children: children }));
};
export var useMyJobsContext = function () {
    var context = useContext(MyJobsContext);
    if (!context) {
        throw new Error('useMyJobsContext must be used within a MyJobsProvider');
    }
    return context;
};
